var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.mountedComponent,_vm._b({tag:"component"},'component',{params: {..._vm.params, ..._vm.componentProps}},false))
}
var staticRenderFns = []

export { render, staticRenderFns }